<script lang="ts" setup>
const { $api } = useNuxtApp()
const { toast } = useToast()
const router = useRouter()
const { t } = useI18n()

const { isAuth } = useAuthStore()

const props = defineProps({
    job: {
        type: Object,
        default: {}
    }
})

const isSaved = ref(false)

onMounted(() => {
    isSaved.value = props.job.is_saved
})

const emit = defineEmits(['refetch-data'])

const savedJob = async () => {
    if (!isAuth) {
        router.push('/login')
    } else {
        isSaved.value = !isSaved.value

        const { error } = await $api.job.savedJob({
            body: { job_id: props.job.id }
        })
        if (!error.value) {
            if (isSaved.value) {
                toast(t('Successfully save job'))
            } else {
                toast(t('Successfully update job'))
                emit('refetch-data')
            }
        }
    }
}
</script>

<template>
    <VBtn
        @click.prevent.stop="savedJob"
        size="small"
        :icon="isSaved ? 'ri-bookmark-fill' : 'ri-bookmark-line'"
        color="error"
        variant="text"
        class="bookmark"
    ></VBtn>
</template>

<style lang="scss">
.bookmark {
    inline-size: 0px !important;
    height: 0px !important;
}
</style>
